import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker/models';
import { AddlocationpopupComponent } from '../../generalpopup/addlocationpopup/addlocationpopup.component';
import { AddbranchpopupComponent } from '../../generalpopup/addbranchpopup/addbranchpopup.component';
import { ApprovepopComponent } from '../../grid/approvepop/approvepop.component';
import { ComponentCanDeactivate } from '../../PendingChangesGuard ';
import { HostListener } from '@angular/core';
import { AttachmentComponent } from '../../grid/attachment/attachment.component';
import { ActivitypopupComponent } from '../../grid/activitypopup/activitypopup.component';

@Component({
  selector: 'app-addtransfer',
  templateUrl: './addtransfer.component.html',
  styleUrls: ['./addtransfer.component.css']
})
export class AddtransferComponent implements OnInit, ComponentCanDeactivate {
  @ViewChild('approvebar', { static: false }) approvebar;
  @ViewChild('attachmentbar', { static: false }) attachmentbar;

  formname: string = "TRANSFER";


  //Display
  formmode: string = "Add";
  rtnform: string = "";

  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;
  isapprovemode: boolean = false;
  isrejectmode: boolean = false;

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;

  isshowattachment: boolean = false;
  attachmentcount: number = 0;

  isbranchaddmode: boolean = false;
  islocationaddmode: boolean = false;

  isshowapproval: boolean = false;

  isapprove: boolean = false;
  isreject: boolean = false;


  ismanualclose: boolean;

  isemploading: boolean = false;

  //Filter
  filterstatus: string = "ALL";
  filteremployeeid: any = null;
  filteremployeename: any = null;
  filterfromdate: any = null;
  filtertodate: any = null;
  //Save Validation
  submitted: boolean;
  successfully: boolean;

  saveloading: boolean;

  //Edit Get Values
  transferColl: any = [];
  transferid: number = 0
  transferBO: any = {}

  locationColl: any = [];
  branchColl: any = [];
  empColl: any = [];
  empBO: any = {};

  checkfeildmsg: any = ""

  transferform = new FormGroup({
    transferid: new FormControl(0),
    branchid: new FormControl(null),
    locationid: new FormControl(null),
    empid: new FormControl(null, Validators.required),
    transdt: new FormControl(null, Validators.required),
    effectivedt: new FormControl(null, Validators.required),
    frombranchid: new FormControl(null),
    fromlocationid: new FormControl(null),
    //adjdt:new FormControl(null,Validators.required),  
    //amount:new FormControl(''), 
    descr: new FormControl(''),
    istemp: new FormControl(false),
    todate: new FormControl(null, Validators.required),
    inactive: new FormControl(false),
  });

  lastbranchname: string = ""
  lastbranchid: any = null;
  lastlocationname: string = ""
  lastlocationid: any = null;
  lasttransferdate: any = null;


  dateCustomClasses: DatepickerDateCustomClasses[];

  constructor(private appService: AppdataService, private loginService: LoginserviceService, private route: ActivatedRoute,
    public router: Router, private toastr: ToastrService, private productFindService: NgbModal, private datePipe: DatePipe) {
    this.route.queryParams.subscribe(params => {
      if (params.id !== undefined) {
        this.transferid = params.id
      }

      if (params.rtnform !== undefined) {
        this.rtnform = params.rtnform
      }
    });
    this.fnGetParameterVariable();

    this.fnServiceChanges();

    this.dateCustomClasses = [
      { date: new Date(), classes: ['bg-warning'] },
    ];
  }
  //Get Para
  fnGetParameterVariable() {
    this.route.queryParams.subscribe(params => {
      if (params.empid !== undefined) {
        this.filteremployeeid = params.empid
      }

      if (params.empname !== undefined) {
        this.filteremployeename = params.empname
      }

      if (params.status !== undefined) {
        this.filterstatus = params.status
      }

      if (params.fromdate !== undefined) {
        this.filterfromdate = this.fnConvertDatetime(this.fnFormatDatetime(params.fromdate))
      }

      if (params.todate !== undefined) {
        this.filtertodate = this.fnConvertDatetime(this.fnFormatDatetime(params.todate))
      }
    })
  }

  fnServiceChanges() {
    this.loginService.serviceAuthChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.fnUserFailedForm();
      }

    });
  }



  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnGetUserRoleList();
      }

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.transferform.reset();
      this.fnInitializeFormGroup();

      if (this.transferid > 0) {
        this.fngetTransfer();
      }
      this.fngetEmployee();
      this.fngetBranch();
      this.fngetLocation();

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.transferid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }


    this.isapprovemode = this.loginService.fnCheckUserRoleAction(this.formname, 'APPROVE')
    this.isrejectmode = this.loginService.fnCheckUserRoleAction(this.formname, 'REJECT')

    this.isbranchaddmode = this.loginService.fnCheckUserRoleAction('Branch', 'CREATE')
    this.islocationaddmode = this.loginService.fnCheckUserRoleAction('Location', 'CREATE')

    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }
  fnInitializeFormGroup() {
    this.transferform.setValue({
      transferid: 0,
      empid: null,
      branchid: null,
      locationid: null,
      transdt: new Date(),
      effectivedt: new Date(),
      frombranchid: null,
      fromlocationid: null,
      descr: '',
      istemp: false,
      todate: null,
      inactive: false
    })
  }


  fngetEmployee() {
    this.isemploading = true;
    var data = {
      'empid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getEmpListView(data)
      .subscribe(
        (res) => {
          this.isemploading = false;
          if (res.json().status === 200) {
            this.empColl = res.json().result;
            this.fnChangeEmpLookup();

          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.isemploading = false;
          this.toastr.error('Error', err);
        })
  }


  fngetBranch() {
    var data = {
      'branchid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getBranch(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.branchColl = res.json().result;
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }



  fngetLocation() {
    var data = {
      'locationid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getLocation(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.locationColl = res.json().result;
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  //Get 
  fngetTransfer() {
    if (this.showProgress) {
      return;
    }
    var data = {
      'transferid': this.transferid,
      'companyid': this.loginService.fnGetCompanyId()
    }
    this.appService.fngetTransfer(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.transferColl = res.json().result;
            var editdata = this.transferColl[0];
            this.transferBO = editdata;
            this.fnEditMode(editdata);
            this.fnHideProgress();

          }
          else {
            this.fnHideProgress();

            this.loginService.fnAPIError(res.json())
          }

        },
        (err) => {
          this.fnHideProgress();

          this.toastr.error('Error', err);
        })
  }

  fnChangeEmpLookup() {
    var empid = 0;

    empid = this.transferform.get("empid").value;

    if (empid > 0) {
      for (let abo of this.empColl) {
        if (abo.empid === empid) {
          this.empBO = abo;
        }
      }

    }
    else {
      this.empBO = {};
    }


  }
  fnResetValidation() {
    if (this.loginService.fnCheckFornControlNotfound(this.transferform.get('effectivedt'))) {
      this.transferform.controls['effectivedt'].setErrors(null);
    }

    if (this.loginService.fnCheckFornControlNotfound(this.transferform.get('branchid'))) {
      this.transferform.controls['branchid'].setErrors(null);
    }

    if (this.loginService.fnCheckFornControlNotfound(this.transferform.get('inactive'))) {
      this.transferform.controls['inactive'].setErrors(null);
    }

  }


  fnValidation() {
    var _ischeck = false;

    if (this.transferform.get('branchid').value === null && this.transferform.get('locationid').value === null) {
      this.transferform.controls['branchid'].setErrors({ 'required': true });
      _ischeck = true;
    }


    if (this.loginService.fnCompareDateValidation(this.transferform.get('effectivedt').value, this.transferform.get('transdt').value)) {
      this.transferform.controls['effectivedt'].setErrors({ 'notfound': true });
      _ischeck = true;
    }

    if (this.transferform.get('branchid').value) {
      if (this.transferform.get('branchid').value === this.transferform.get('frombranchid').value) {
        this.transferform.controls['branchid'].setErrors({ 'notfound': true });
        _ischeck = true;
      }
    }

    if (this.transferform.get('locationid').value) {
      if (this.transferform.get('locationid').value === this.transferform.get('fromlocationid').value) {
        this.transferform.controls['locationid'].setErrors({ 'notfound': true });
        _ischeck = true;
      }
    }


    return _ischeck;

  }
  //Save Btn Click
  fnSaveBtnClick() {
    try {
      if (this.saveloading) {
        return;
      }

      this.submitted = true;
      this.successfully = false;

      this.fnResetValidation();
      //Validate
      if (this.transferform.valid) {


        if (this.fnValidation()) {
          return false
        }
        this.saveloading = true;



        //Check
        var data = {
          'transferid': this.transferid,
          'transdt': this.fnFormatDatetime(this.transferform.get('transdt').value),
          'effectivedt': this.fnFormatDatetime(this.transferform.get('effectivedt').value),
          'empid': this.transferform.get('empid').value,
          'branchid': this.transferform.get('branchid').value,
          'locationid': this.transferform.get('locationid').value,
          'frombranchid': this.transferform.get('frombranchid').value,
          'fromlocationid': this.transferform.get('fromlocationid').value,
          'descr': this.transferform.get('descr').value,
          'istemp': this.transferform.get('istemp').value,
          'todate': this.fnFormatDatetime(this.transferform.get('todate').value),
          'inactive': this.transferform.get('inactive').value,
          'companyid': this.loginService.fnGetCompanyId(),
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
        }


        this.appService.fnCheckTransfer(data).subscribe(
          (res) => {
            if (res.json().status === 200) {
              var _checkresponce = res.json().result[0];

              var _checkresult = _checkresponce.checkfield;

              if (_checkresult === 'done') {
                if (this.transferform.get('transferid').value > 0) {
                  //Update 
                  this.fnSetTransfer(data);
                }
                else {
                  //Insert 
                  this.fnInsertTransfer(data);
                }
              }
              else {
                if (_checkresult === "COMMON") {
                  this.saveloading = false;
                  this.checkfeildmsg = _checkresponce.checkvaluemsg;

                  this.transferform.controls['inactive'].setErrors({ 'notfound': true });
                }
              }
            }
          }, (err) => {
            this.toastr.error('Error', err);
          });


      }
      else {
        console.log(this.transferform)
      }
    } catch (ex) {
      this.saveloading = false;

      this.fnShowErrorMsg(ex);
    }
  }


  //Insert
  fnInsertTransfer(data) {

    this.appService.fnInsertTransfer(data).subscribe(
      (res) => {
        this.saveloading = false;
        if (res.json().status === 200) {
          if (res.json().result != "") {
            this.fnResetSaveFlag();
            this.toastr.success('', "The new Transfer has been added successfully.Insert Successfully");
            this.fnInsertActivityLog('INSERT', 0, this.fngetDescriptionRefno(data));

            var _result = res.json().result;
            if (_result.length > 0) {
              this.fnEditFormEdit(_result[0].transferid);
            }

          }
        }
        else {
          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => {
        this.saveloading = false;
        this.toastr.error('Error', err);
      });

  }

  //Set
  fnSetTransfer(data) {

    this.appService.fnSetTransfer(data).subscribe(
      (res) => {
        this.saveloading = false;
        if (res.json().status === 200) {
          if (res.json().result != "") {
            this.fnResetSaveFlag();
            this.toastr.success('', "The Transfer has been updated successfully.");
            this.fnInsertActivityLog('EDIT', this.transferid, this.fngetDescriptionRefno(data));
            this.fnEditFormEdit(this.transferid);
            // this.ismanualclose = true;
            // this.fnCloseForm();
          }
        }
        else {
          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => {
        this.saveloading = false;
        this.toastr.error('Error', err);
      });

  }

  //AddLocation
  private fnAddLocation() {

    const modalRef = this.productFindService.open(AddlocationpopupComponent, { size: <any>'l' });

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      this.fngetLocation();

      if (receivedEntry > 0) {
        this.transferform.patchValue({ locationid: receivedEntry })
      }
    });

  }

  fnEmployeeSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.empname.toLocaleLowerCase().indexOf(term) > -1 ||
      item.staffcode.toLocaleLowerCase().indexOf(term) > -1;
  }


  //AddBranch
  private fnAddBranch() {

    const modalRef = this.productFindService.open(AddbranchpopupComponent, { size: <any>'l' });

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      this.fngetBranch();

      if (receivedEntry > 0) {
        this.transferform.patchValue({ branchid: receivedEntry })
      }
    });

  }

  fnEditFormEdit(id) {

    this.transferid = id;
    this.isaddmode = false;
    this.iseditmode = false;
    this.isdeletemode = false;
    this.isviewmode = true;


    let queryParams = {
      'id': id,
      'status': this.filterstatus,
      'empid': this.filteremployeeid,
      'empname': this.filteremployeename,
      'fromdate': this.fnFormatDatetime(this.filterfromdate),
      'todate': this.fnFormatDatetime(this.filtertodate),
    }

    this.router.navigate([], { relativeTo: this.route, queryParams: queryParams }).then(() => {
      this.ngOnInit();
    });


  }
  //Close
  async fnCloseForm() {
    try {
      if ((this.isaddmode || this.iseditmode) && !this.ismanualclose) {
        var a = await this.loginService.fnConfirmFormLeave();
        if (a === false) {
          return false;
        }
      }

      this.ismanualclose = true;
      if (this.rtnform !== '') {
        this.router.navigate(['/' + this.rtnform]);
      }
      else {
        let navigationExtras: NavigationExtras = {
          queryParams: {
            'status': this.filterstatus,
            'empid': this.filteremployeeid,
            'empname': this.filteremployeename,
            'fromdate': this.fnFormatDatetime(this.filterfromdate),
            'todate': this.fnFormatDatetime(this.filtertodate),
          }
        }

        this.router.navigate(['/Transfer'], navigationExtras);
      }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  private fnEditMode(deptBO) {
    deptBO.effectivedt = this.fnConvertDatetime(this.fnFormatDatetime(deptBO.effectivedt));
    deptBO.transdt = this.fnConvertDatetime(this.fnFormatDatetime(deptBO.transdt));
    deptBO.todate = this.fnConvertDatetime(this.fnFormatDatetime(deptBO.todate));
    
    this.transferform.setValue({
      transferid: deptBO.transferid,
      empid: deptBO.empid,
      branchid: deptBO.branchid,
      locationid: deptBO.locationid,
      frombranchid: deptBO.frombranchid,
      fromlocationid: deptBO.fromlocationid,
      effectivedt: deptBO.effectivedt,
      transdt: deptBO.transdt,
      descr: deptBO.descr,
      istemp: deptBO.istemp,
      todate: deptBO.todate,
      inactive: deptBO.inactive
    });


    this.formmode = "";

    this.isaddmode = false;
    this.iseditmode = false;
    this.isdeletemode = false;
    this.isviewmode = true;

    this.fnVisibilityApproveStatus();
    this.fnChangeEmpLookup();
    this.fnGetAttachmentCount();

    this.lastbranchid = deptBO.frombranchid;
    this.lastbranchname = deptBO.frombranchname;
    this.lastlocationid = deptBO.fromlocationid;
    this.lastlocationname = deptBO.fromlocationname;
  }

  fnGetCurrentBranchLocation() {

    if (this.transferid > 0) {
      return;
    }

    var empid = this.transferform.get("empid").value;

    if (empid > 0) {
      for (let abo of this.empColl) {

        if (abo.empid === empid) {

          this.lastbranchid = abo.branchid;
          this.lastbranchname = abo.branchname;
          this.lastlocationid = abo.locationid;
          this.lastlocationname = abo.locationname;
          this.lasttransferdate = abo.transferdt;
        }
      }

    }
    else {
      this.lastbranchid = null;
      this.lastlocationid = null;
      this.lastbranchname = "";
      this.lastlocationname = "";
      this.lasttransferdate = "";
    }

    this.transferform.patchValue({
      frombranchid: this.lastbranchid,
      fromlocationid: this.lastlocationid,
    })

  }

  //Approvals
  fnApproveBtnClick(type) {


    this.approvebar.formtype = type;
    this.approvebar.fnInitializeFormGroup();
    this.approvebar.fnGetApproveForms();

    this.isshowapproval = !this.isshowapproval

  }

  fnCloseApproveBtnClick(data) {
    this.isshowapproval = !this.isshowapproval

    if (data === 'DONE') {
      this.fngetTransfer();
    }

  }

  fnVisibilityApproveStatus() {

    this.isapprove = false;
    this.isreject = false;

    if (this.transferBO.approvedstatus !== '') {
      if (this.transferBO.approvedstatus === 'Approve') {
        this.isreject = true;
      }
      else if (this.transferBO.approvedstatus === 'Reject') {
        this.isapprove = true;
      }
    }
    else {
      this.isapprove = true;
      this.isreject = true;
    }

  }

  fnEditBtnClick() {
    this.iseditmode = true;

    this.isviewmode = false;
  }
  //#Attachment
  fnAttachmentBtnClick() {

    const modalRef = this.productFindService.open(AttachmentComponent, { size: <any>'xxl' });
    modalRef.componentInstance.formname = this.formname;
    modalRef.componentInstance.trxid = this.transferid;
    modalRef.componentInstance.formmode = "EDIT";
    modalRef.componentInstance.fnGetAttachment();


    modalRef.result.then(() => {
      this.fnGetAttachmentCount()
    }, () => {
      this.fnGetAttachmentCount()
    })

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {
      if (receivedEntry === 'DONE') {
        this.fngetTransfer();
      }
    });


  }


  fnAttachmentSave(tid) {



  }

  fnSetAttachmentCount(data) {

    this.attachmentcount = data;
  }


  //Attachment
  fnGetAttachmentCount() {
    if (this.transferid > 0) {
      var data = {
        'trxid': this.transferid,
        'trxtype': this.formname,
      }


      this.appService.fngetAttachmentCountDetails(data).subscribe(
        (res) => {
          if (res.json().status === 200) {
            var result = res.json().result;
            if (result.length > 0) {
              this.attachmentcount = result[0].attachmentcount
            }
          }
          else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        });
    }

  }




  //Approvals POP
  fnShowApprovalPop(stauts) {

    const modalRef = this.productFindService.open(ApprovepopComponent, { size: <any>'l' });
    modalRef.componentInstance.formmode = stauts;
    modalRef.componentInstance.formname = this.formname;
    modalRef.componentInstance.formid = this.transferid;

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      if (receivedEntry === 'DONE') {
        this.fngetTransfer();
      }


    });
  }
  fnAddActivity() {

    const modalRef = this.productFindService.open(ActivitypopupComponent, { size: <any>'l' });
    modalRef.componentInstance.formname = this.formname;
    modalRef.componentInstance.trxid = this.transferid;

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {


    });

  }

  fnFormatDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        return this.datePipe.transform(dt, "yyyy-MM-dd")
      }

    } else {
      return null
    }

  }

  fnConvertDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        var dateParts = dt.split("-");
        var sdate = new Date(+dateParts[0], dateParts[1] - 1, +dateParts[2] + 1);
        sdate.setMinutes(sdate.getMinutes() + sdate.getTimezoneOffset());
        return sdate;
      }

    } else {
      return null
    }

  }

  fngetDescriptionRefno(data) {
    var rtnstr = "";
    try {
      if (data.transdt) {
        rtnstr = rtnstr + data.transdt;
      }

      if (data.empid) {
        rtnstr = rtnstr + " - " + data.empid;
      }

      if (data.empname) {
        rtnstr = rtnstr + " - " + data.empname;
      }
    } catch {

    }
    return rtnstr;
  }
  @HostListener('window:beforeunload')
  canDeactivate(): any {
    if (this.isaddmode || this.iseditmode) {
      return false;
    }
    else {
      return true;
    }
  }

  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc, companyid: this.loginService.fnGetCompanyId(),
        logby: this.loginService.fnGetModUserId(),
      }


      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch {

    }
  }
  fnResetSaveFlag() {
    this.submitted = false;
    this.successfully = false;
  }
  private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  }
  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }







}